import React from "react"
import styled from "@emotion/styled"
import tw, { theme } from "twin.macro"

const Container = tw.div`px-12 py-4 center-y justify-between fixed bottom-0 bg-white w-screen z-50`
const Link = tw.a`underline cursor-pointer font-medium text-xs md:text-sm`
const Text = styled.div`
    ${theme`typo.mregular`}
    ${tw`text-text_body`}
    ${tw`text-[10px] md:text-[14px]`}
`

export default function FooterTermsCons() {
    return (
        <Container>
            <div>
                <Text>© Copyright 2023, Seedooh PTY LTD All rights reserved. </Text>
                <Text>
                    Only Strictly Necessary Cookies are placed here. Login to access full cookie
                    management.
                </Text>
            </div>
            <div tw="ml-6">
                <Link href="/terms.pdf" rel="noopener noreferrer" target="_blank">
                    Legal
                </Link>
                <Link
                    tw="ml-6"
                    href="/privacy-policy.pdf"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    Privacy
                </Link>
            </div>
        </Container>
    )
}
